// BabyMobile.ca — real wool-blend felt colour swatches (matches the
// physical swatch card customers can request), shared by the custom order
// configurator and the product page banner calculator.
window.RD_FELT_COLORS = [
  { name: 'White', hex: '#F5F5F0' },
  { name: 'Linen', hex: '#F0EDE5' },
  { name: 'Porcelain Skin', hex: '#EAE6DC' },
  { name: 'Cream', hex: '#F3EFDD' },
  { name: 'Opal', hex: '#D6D9D5' },
  { name: 'Sandstone', hex: '#C7C2A0' },
  { name: 'Clay', hex: '#B9B79A' },
  { name: 'Straw', hex: '#D9CE9C' },
  { name: 'Pastry', hex: '#E8D9B5' },
  { name: 'Champagne', hex: '#DCC6A8' },
  { name: 'Tan', hex: '#C7A374' },
  { name: 'Camel', hex: '#B98D5A' },
  { name: 'Cinnamon', hex: '#8B4A2B' },
  { name: 'Rust', hex: '#A13A1F' },
  { name: 'Dark Copper', hex: '#7A2E14' },
  { name: 'Bark', hex: '#4A2E1E' },
  { name: 'Brown', hex: '#241611' },
  { name: 'Apricot', hex: '#F0C89A' },
  { name: 'Honey', hex: '#EFC97A' },
  { name: 'Georgia Peach', hex: '#F0A87E' },
  { name: 'Charming Coral', hex: '#F4877E' },
  { name: 'Pumpkin Spice', hex: '#C7622A' },
  { name: 'Carrot', hex: '#E8791E' },
  { name: 'Sunburst', hex: '#E85E1B' },
  { name: 'Persimmon', hex: '#D8341F' },
  { name: 'Custard', hex: '#EDE397' },
  { name: 'Lemon', hex: '#F3E357' },
  { name: 'Mellow Yellow', hex: '#F0D22A' },
  { name: 'Eternal Sunshine', hex: '#F5CB19' },
  { name: 'Mustard', hex: '#B78B1E' },
  { name: 'Old Gold', hex: '#B79A2C' },
  { name: 'Peachy Pink', hex: '#EFD3C4' },
  { name: 'Pink Frosting', hex: '#F2DCE1' },
  { name: 'Ballet Slippers', hex: '#F4CDDA' },
  { name: 'Pink', hex: '#F5A9C0' },
  { name: 'Blushing Bride', hex: '#F0BFAF' },
  { name: 'Terracotta', hex: '#DE9683' },
  { name: 'Cameo Pink', hex: '#E3ABA8' },
  { name: 'Cotton Candy', hex: '#F5AFC4' },
  { name: 'Pink Violet', hex: '#EC7FA8' },
  { name: 'English Rose', hex: '#E9668E' },
  { name: 'Coral', hex: '#F0765F' },
  { name: 'Fuchsia', hex: '#D31C7E' },
  { name: 'Rose Petal', hex: '#C41B6E' },
  { name: 'Ruby Red', hex: '#A81C40' },
  { name: 'Strawberry', hex: '#C41F3B' },
  { name: 'Bright Red', hex: '#CE1620' },
  { name: 'Red Rose', hex: '#B31923' },
  { name: 'Red Velvet', hex: '#8C1420' },
  { name: 'Garnet', hex: '#5F1119' },
  { name: 'Burgundy', hex: '#5E141C' },
  { name: 'Blue Snow', hex: '#C6DBDB' },
  { name: 'Baby Blue', hex: '#A9DEE0' },
  { name: 'Aqua', hex: '#4DD3D8' },
  { name: 'Ocean Mist', hex: '#A9C1BE' },
  { name: "Robin's Egg", hex: '#A9C8DF' },
  { name: 'Periwinkle', hex: '#7C93CB' },
  { name: 'Columbia Blue', hex: '#4FA9CB' },
  { name: 'Blue Bayou', hex: '#1D9CC4' },
  { name: 'Tropical Wave', hex: '#17A9C9' },
  { name: 'Peacock', hex: '#0F8C93' },
  { name: 'Blueberry', hex: '#2B4F9E' },
  { name: 'Royal Blue', hex: '#17237A' },
  { name: 'Midnight', hex: '#131638' },
  { name: 'Hint of Mint', hex: '#E4EEDD' },
  { name: 'Pistachio', hex: '#D4E39A' },
  { name: 'Chartreuse', hex: '#BBDA1E' },
  { name: 'Matcha', hex: '#8FAE4A' },
  { name: 'Oregano', hex: '#6C7A34' },
  { name: 'Moss', hex: '#566219' },
  { name: 'Enchanted Forest', hex: '#B7CBB0' },
  { name: 'Relish', hex: '#7EA83A' },
  { name: 'Sage', hex: '#A6B692' },
  { name: 'Olive', hex: '#6C7024' },
  { name: 'Grassy Meadows', hex: '#35521C' },
  { name: 'Neo Mint', hex: '#AEE3C4' },
  { name: 'Clover', hex: '#6FBB8A' },
  { name: 'Blue Spruce', hex: '#3D7C5F' },
  { name: 'Babbling Brook', hex: '#B7D8CB' },
  { name: 'Spring Green', hex: '#7EDB8E' },
  { name: 'Kelly Green', hex: '#2C9A4E' },
  { name: 'Hunter Green', hex: '#1B5738' },
  { name: 'Evergreen', hex: '#0F3D26' },
  { name: 'Sweet Lavender', hex: '#DAD7E8' },
  { name: 'Field of Lilacs', hex: '#C9C1E0' },
  { name: 'Wisteria', hex: '#C7ABCE' },
  { name: 'Hydrangea', hex: '#9C6FA8' },
  { name: 'Mulberry', hex: '#8C2B72' },
  { name: 'Lavender', hex: '#8055A8' },
  { name: 'Grape', hex: '#5A2382' },
  { name: 'Purple', hex: '#401A73' },
  { name: 'Vineyard', hex: '#6D5D74' },
  { name: 'Morning Air', hex: '#C1C1C6' },
  { name: 'Silver Grey', hex: '#C9CBCB' },
  { name: 'Heather Grey', hex: '#A6A6A8' },
  { name: 'Driftwood', hex: '#B7B2A6' },
  { name: 'Pepper', hex: '#6E7679' },
  { name: 'Storm Clouds', hex: '#6C7C7E' },
  { name: 'Smoke', hex: '#35404A' },
  { name: 'Black', hex: '#0C0C0C' }
];

// Shared swatch popover: click a trigger element, pick a colour, get it back.
(function () {
  var openPopover = null;
  var openTrigger = null;

  function closePopover() {
    if (openPopover) {
      openPopover.remove();
      openPopover = null;
      openTrigger = null;
    }
  }

  document.addEventListener('click', function (e) {
    if (openPopover && !openPopover.contains(e.target) && e.target !== openTrigger) {
      closePopover();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopover();
  });

  window.RDOpenColorPicker = function (anchorEl, onPick) {
    if (openTrigger === anchorEl) {
      closePopover();
      return;
    }
    closePopover();

    var pop = document.createElement('div');
    pop.className = 'rd-color-popover';

    var grid = document.createElement('div');
    grid.className = 'rd-color-popover-grid';

    window.RD_FELT_COLORS.forEach(function (c) {
      var sw = document.createElement('button');
      sw.type = 'button';
      sw.className = 'rd-color-swatch';
      sw.setAttribute('aria-label', c.name);

      var circle = document.createElement('span');
      circle.className = 'rd-color-swatch-circle';
      circle.style.background = c.hex;

      var label = document.createElement('span');
      label.className = 'rd-color-swatch-label';
      label.textContent = c.name;

      sw.appendChild(circle);
      sw.appendChild(label);
      sw.addEventListener('click', function (e) {
        e.stopPropagation();
        onPick(c);
        closePopover();
      });
      grid.appendChild(sw);
    });

    pop.appendChild(grid);

    if (window.RD_FELT_SWATCH_IMG) {
      var refWrap = document.createElement('a');
      refWrap.className = 'rd-color-popover-ref';
      refWrap.href = window.RD_FELT_SWATCH_IMG;
      refWrap.target = '_blank';
      refWrap.rel = 'noopener';
      refWrap.title = 'Open full-size reference photo';

      var refImg = document.createElement('img');
      refImg.src = window.RD_FELT_SWATCH_IMG;
      refImg.alt = 'Real wool felt colour swatches reference photo';
      refImg.loading = 'lazy';

      var refCaption = document.createElement('span');
      refCaption.className = 'rd-color-popover-ref-caption';
      refCaption.textContent = 'Real swatch photo';

      refWrap.appendChild(refImg);
      refWrap.appendChild(refCaption);
      pop.appendChild(refWrap);
    }

    document.body.appendChild(pop);

    var rect = anchorEl.getBoundingClientRect();
    var popWidth = pop.offsetWidth;
    var top = rect.bottom + window.scrollY + 6;
    var left = rect.left + window.scrollX;
    if (left + popWidth > window.innerWidth - 12) {
      left = Math.max(12, window.innerWidth - popWidth - 12);
    }
    pop.style.top = top + 'px';
    pop.style.left = left + 'px';

    openPopover = pop;
    openTrigger = anchorEl;
  };

  window.RDCloseColorPicker = closePopover;
})();
